var r=function(r,e){return r===e||r!=r&&e!=e};export{r as e};
